import React, { useEffect, useState, Suspense } from 'react';
import './assets/styles/base.scss';
import './assets/styles/fonts/fonts.scss';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import routes from './routes';
import SplashScreen from './shared/services/general/splashScreen';
import SeoManager from './shared/services/general/seoManager';
import { SkeletonTheme } from 'react-loading-skeleton';

// Lazy loading components
const Header = React.lazy(() => import('./components/header/header'));
const Navigator = React.lazy(() => import('./components/mobile-navigator/mobile-navigator'));

function App() {
	const [isWebView, setIsWebView] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Android WebView
		const isAndroidWebView = /wv/.test(userAgent) && /Android/.test(userAgent);

		// iOS WebView
		const isIOSWebView = /iPhone|iPod|iPad/.test(userAgent) && !window.MSStream && !window.indexedDB;

		if (isAndroidWebView || isIOSWebView) {
			setIsWebView(true);
		}
		const timer = setTimeout(() => {
			setLoading(false);
		}, 2000);

		return () => clearTimeout(timer);
	}, []);

	const location = useLocation();

	const currentRoute = routes.find(route => {
		const regex = new RegExp(`^${route.path.replace(/:\w+/g, '\\w+')}$`);
		return regex.test(location.pathname);
	});

	const externalStyle = currentRoute?.externalStyle || false;

	return (
		<>
			<SeoManager>
				<SkeletonTheme baseColor="#322c42" highlightColor="#68627a">
					<main>
						{isWebView && loading && <SplashScreen />}
						{!externalStyle && (
							<section
								id="content-section"
								className={
									location?.pathname === '/' || location?.pathname === '/movies' || location?.pathname === '/series'
										? 'main-page'
										: 'not-show'
								}
							>
								<Suspense fallback={<header id="header"></header>}>
									<Header />
								</Suspense>
								<section className={`main-section ${isWebView ? 'webview-class' : ''}`}>
									<Suspense fallback={<div>Loading Pages...</div>}>
										<Switch>
											{routes.map((route, index) => (
												<Route key={index} {...route} />
											))}
											<Redirect to="/404" />
										</Switch>
									</Suspense>
								</section>
								<Suspense fallback={<div className="mob-nav"><div id="navigator"></div></div>}>
									<Navigator />
								</Suspense>
								{/*<Footer />*/}
							</section>
						)}
						{externalStyle && (
							<Switch>
								{routes.map((route, index) => (
									<Route key={index} {...route} />
								))}
								<Redirect to="/404" />
							</Switch>
						)}
					</main>
				</SkeletonTheme>
			</SeoManager>
		</>
	);
}

export default App;
